import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

export default function Arama() {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('date_desc');
  const [viewMode, setViewMode] = useState('grid');

  const resetFilters = () => {
    // Reset all filter states here
    console.log('Filters reset');
  };

  const search = () => {
    // Implement search functionality
    console.log('Searching for:', searchQuery);
  };

  const sortResults = (value: string) => {
    setSortBy(value);
    // Implement sorting functionality
    console.log('Sorting by:', value);
  };

  return (
    <div>
      {/* Header buraya gelecek */}
      <main className="container mt-4">
        <div className="row">
          {/* Sol Filtreler */}
          <div className="col-lg-3">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  Filtreler
                </h5>
                <Button className="btn btn-sm btn-outline-secondary" onClick={resetFilters}>
                  <i className="fas fa-undo me-2" />
                  Sıfırla
                </Button>
              </div>
              <div className="card-body">
                {/* Kategori Filtresi */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Kategori
                  </label>
                  <div className="category-tree">
                    {/* Bilgisayar */}
                    <div className="category-item">
                      <div className="form-check d-flex align-items-center">
                        <input className="form-check-input" id="catComputer" type="checkbox"/>
                        <label className="form-check-label ms-2" htmlFor="catComputer">
                          Bilgisayar
                        </label>
                        <Button className="btn btn-sm ms-auto" data-bs-target="#computerSubcats" data-bs-toggle="collapse" type="button">
                          <i className="fas fa-chevron-down">
                          </i>
                        </Button>
                      </div>
                      <div className="collapse ps-4" id="computerSubcats">
                        {/* Dizüstü Bilgisayar */}
                        <div className="category-item">
                          <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" id="catLaptop" type="checkbox"/>
                            <label className="form-check-label ms-2" htmlFor="catLaptop">
                              Dizüstü Bilgisayar
                            </label>
                            <Button className="btn btn-sm ms-auto" data-bs-target="#laptopSpecs" data-bs-toggle="collapse" type="button">
                              <i className="fas fa-chevron-down">
                              </i>
                            </Button>
                          </div>
                          <div className="collapse ps-4" id="laptopSpecs">
                            <div className="mb-3">
                              <label className="form-label">
                                İşlemci
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="intel_i3">
                                  Intel i3
                                </option>
                                <option value="intel_i5">
                                  Intel i5
                                </option>
                                <option value="intel_i7">
                                  Intel i7
                                </option>
                                <option value="intel_i9">
                                  Intel i9
                                </option>
                                <option value="amd_ryzen3">
                                  AMD Ryzen 3
                                </option>
                                <option value="amd_ryzen5">
                                  AMD Ryzen 5
                                </option>
                                <option value="amd_ryzen7">
                                  AMD Ryzen 7
                                </option>
                                <option value="amd_ryzen9">
                                  AMD Ryzen 9
                                </option>
                              </select>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">
                                RAM
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="4gb">
                                  4 GB
                                </option>
                                <option value="8gb">
                                  8 GB
                                </option>
                                <option value="16gb">
                                  16 GB
                                </option>
                                <option value="32gb">
                                  32 GB
                                </option>
                                <option value="64gb">
                                  64 GB
                                </option>
                              </select>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">
                                Ekran Kartı
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="nvidia_rtx">
                                  NVIDIA RTX Serisi
                                </option>
                                <option value="nvidia_gtx">
                                  NVIDIA GTX Serisi
                                </option>
                                <option value="amd_radeon">
                                  AMD Radeon
                                </option>
                                <option value="integrated">
                                  Dahili Ekran Kartı
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        {/* Masaüstü Bilgisayar */}
                        <div className="category-item">
                          <div className="form-check d-flex align-items-center">
                            <input className="form-check-input" id="catDesktop" type="checkbox"/>
                            <label className="form-check-label ms-2" htmlFor="catDesktop">
                              Masaüstü Bilgisayar
                            </label>
                            <Button className="btn btn-sm ms-auto" data-bs-target="#desktopSpecs" data-bs-toggle="collapse" type="button">
                              <i className="fas fa-chevron-down">
                              </i>
                            </Button>
                          </div>
                          <div className="collapse ps-4" id="desktopSpecs">
                            {/* Masaüstü Tipi */}
                            <div className="mb-3">
                              <label className="form-label">
                                Masaüstü Tipi
                              </label>
                              <div className="form-check">
                                <input className="form-check-input" id="customPC" name="desktopType" type="radio"/>
                                <label className="form-check-label" htmlFor="customPC">
                                  Toplama Bilgisayar
                                </label>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" id="brandPC" name="desktopType" type="radio"/>
                                <label className="form-check-label" htmlFor="brandPC">
                                  Hazır Sistem
                                </label>
                              </div>
                            </div>
                            {/* Marka (Hazır Sistem için) */}
                            <div className="mb-3 brand-select" style={{ display: 'none' }}>
                              <label className="form-label">
                                Marka
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="asus">
                                  ASUS
                                </option>
                                <option value="msi">
                                  MSI
                                </option>
                                <option value="hp">
                                  HP
                                </option>
                                <option value="dell">
                                  Dell
                                </option>
                                <option value="lenovo">
                                  Lenovo
                                </option>
                                <option value="acer">
                                  Acer
                                </option>
                                <option value="casper">
                                  Casper
                                </option>
                                <option value="monster">
                                  Monster
                                </option>
                              </select>
                            </div>
                            {/* İşlemci */}
                            <div className="mb-3">
                              <label className="form-label">
                                İşlemci
                              </label>
                              <select className="form-select form-select-sm mb-2">
                                <option value="">
                                  Marka Seçin
                                </option>
                                <option value="intel">
                                  Intel
                                </option>
                                <option value="amd">
                                  AMD
                                </option>
                              </select>
                              {/* Intel İşlemciler */}
                              <select className="form-select form-select-sm intel-cpus" multiple={true} style={{ display: 'none' }}>
                                <optgroup label="13. Nesil">
                                  <option value="i3_13100">
                                    i3-13100
                                  </option>
                                  <option value="i5_13400">
                                    i5-13400
                                  </option>
                                  <option value="i5_13600K">
                                    i5-13600K
                                  </option>
                                  <option value="i7_13700K">
                                    i7-13700K
                                  </option>
                                  <option value="i9_13900K">
                                    i9-13900K
                                  </option>
                                </optgroup>
                                <optgroup label="12. Nesil">
                                  <option value="i3_12100">
                                    i3-12100
                                  </option>
                                  <option value="i5_12400">
                                    i5-12400
                                  </option>
                                  <option value="i5_12600K">
                                    i5-12600K
                                  </option>
                                  <option value="i7_12700K">
                                    i7-12700K
                                  </option>
                                  <option value="i9_12900K">
                                    i9-12900K
                                  </option>
                                </optgroup>
                              </select>
                              {/* AMD İşlemciler */}
                              <select className="form-select form-select-sm amd-cpus" multiple={true} style={{ display: 'none' }}>
                                <optgroup label="Ryzen 7000 Serisi">
                                  <option value="r5_7600X">
                                    Ryzen 5 7600X
                                  </option>
                                  <option value="r7_7700X">
                                    Ryzen 7 7700X
                                  </option>
                                  <option value="r9_7900X">
                                    Ryzen 9 7900X
                                  </option>
                                  <option value="r9_7950X">
                                    Ryzen 9 7950X
                                  </option>
                                </optgroup>
                                <optgroup label="Ryzen 5000 Serisi">
                                  <option value="r5_5600X">
                                    Ryzen 5 5600X
                                  </option>
                                  <option value="r7_5800X">
                                    Ryzen 7 5800X
                                  </option>
                                  <option value="r9_5900X">
                                    Ryzen 9 5900X
                                  </option>
                                  <option value="r9_5950X">
                                    Ryzen 9 5950X
                                  </option>
                                </optgroup>
                              </select>
                            </div>
                            {/* RAM */}
                            <div className="mb-3">
                              <label className="form-label">
                                RAM
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="1gb">
                                  1 GB
                                </option>
                                <option value="2gb">
                                  2 GB
                                </option>
                                <option value="4gb">
                                  4 GB
                                </option>
                                <option value="8gb">
                                  8 GB
                                </option>
                                <option value="16gb">
                                  16 GB
                                </option>
                                <option value="32gb">
                                  32 GB
                                </option>
                                <option value="64gb">
                                  64 GB
                                </option>
                                <option value="128gb">
                                  128 GB ve üzeri
                                </option>
                              </select>
                            </div>
                            {/* Ekran Kartı */}
                            <div className="mb-3">
                              <label className="form-label">
                                Ekran Kartı
                              </label>
                              <select className="form-select form-select-sm mb-2">
                                <option value="">
                                  Marka Seçin
                                </option>
                                <option value="nvidia">
                                  NVIDIA
                                </option>
                                <option value="amd">
                                  AMD
                                </option>
                                <option value="intel">
                                  Intel
                                </option>
                                <option value="integrated">
                                  Dahili Ekran Kartı
                                </option>
                                <option value="none">
                                  Yok
                                </option>
                              </select>
                              {/* NVIDIA Ekran Kartları */}
                              <select className="form-select form-select-sm nvidia-gpus" multiple={true} style={{ display: 'none' }}>
                                <optgroup label="RTX 40 Serisi">
                                  <option value="rtx4090">
                                    RTX 4090
                                  </option>
                                  <option value="rtx4080">
                                    RTX 4080
                                  </option>
                                  <option value="rtx4070ti">
                                    RTX 4070 Ti
                                  </option>
                                  <option value="rtx4070">
                                    RTX 4070
                                  </option>
                                </optgroup>
                                <optgroup label="RTX 30 Serisi">
                                  <option value="rtx3090ti">
                                    RTX 3090 Ti
                                  </option>
                                  <option value="rtx3090">
                                    RTX 3090
                                  </option>
                                  <option value="rtx3080ti">
                                    RTX 3080 Ti
                                  </option>
                                  <option value="rtx3080">
                                    RTX 3080
                                  </option>
                                  <option value="rtx3070ti">
                                    RTX 3070 Ti
                                  </option>
                                  <option value="rtx3070">
                                    RTX 3070
                                  </option>
                                  <option value="rtx3060ti">
                                    RTX 3060 Ti
                                  </option>
                                  <option value="rtx3060">
                                    RTX 3060
                                  </option>
                                </optgroup>
                              </select>
                              {/* AMD Ekran Kartları */}
                              <select className="form-select form-select-sm amd-gpus" multiple={true} style={{ display: 'none' }}>
                                <optgroup label="RX 7000 Serisi">
                                  <option value="rx7900xtx">
                                    RX 7900 XTX
                                  </option>
                                  <option value="rx7900xt">
                                    RX 7900 XT
                                  </option>
                                  <option value="rx7800xt">
                                    RX 7800 XT
                                  </option>
                                </optgroup>
                                <optgroup label="RX 6000 Serisi">
                                  <option value="rx6950xt">
                                    RX 6950 XT
                                  </option>
                                  <option value="rx6900xt">
                                    RX 6900 XT
                                  </option>
                                  <option value="rx6800xt">
                                    RX 6800 XT
                                  </option>
                                  <option value="rx6800">
                                    RX 6800
                                  </option>
                                  <option value="rx6750xt">
                                    RX 6750 XT
                                  </option>
                                  <option value="rx6700xt">
                                    RX 6700 XT
                                  </option>
                                  <option value="rx6650xt">
                                    RX 6650 XT
                                  </option>
                                </optgroup>
                              </select>
                            </div>
                            {/* Depolama */}
                            <div className="mb-3">
                              <label className="form-label">
                                Depolama
                              </label>
                              {/* SSD */}
                              <div className="mb-2">
                                <label className="form-label small">
                                  SSD
                                </label>
                                <select className="form-select form-select-sm" multiple={true}>
                                  <option value="ssd_128">
                                    128 GB
                                  </option>
                                  <option value="ssd_256">
                                    256 GB
                                  </option>
                                  <option value="ssd_512">
                                    512 GB
                                  </option>
                                  <option value="ssd_1024">
                                    1 TB
                                  </option>
                                  <option value="ssd_2048">
                                    2 TB
                                  </option>
                                  <option value="ssd_4096">
                                    4 TB
                                  </option>
                                  <option value="ssd_8192">
                                    8 TB ve üzeri
                                  </option>
                                </select>
                              </div>
                              {/* HDD */}
                              <div>
                                <label className="form-label small">
                                  Sabit Disk
                                </label>
                                <select className="form-select form-select-sm" multiple={true}>
                                  <option value="hdd_500">
                                    500 GB
                                  </option>
                                  <option value="hdd_1000">
                                    1 TB
                                  </option>
                                  <option value="hdd_2000">
                                    2 TB
                                  </option>
                                  <option value="hdd_4000">
                                    4 TB
                                  </option>
                                  <option value="hdd_6000">
                                    6 TB
                                  </option>
                                  <option value="hdd_8000">
                                    8 TB
                                  </option>
                                  <option value="hdd_10000">
                                    10 TB ve üzeri
                                  </option>
                                </select>
                              </div>
                            </div>
                            {/* Güç Kaynağı */}
                            <div className="mb-3">
                              <label className="form-label">
                                Güç Kaynağı
                              </label>
                              <select className="form-select form-select-sm" multiple={true}>
                                <option value="psu_300">
                                  300W
                                </option>
                                <option value="psu_400">
                                  400W
                                </option>
                                <option value="psu_500">
                                  500W
                                </option>
                                <option value="psu_600">
                                  600W
                                </option>
                                <option value="psu_700">
                                  700W
                                </option>
                                <option value="psu_800">
                                  800W
                                </option>
                                <option value="psu_1000">
                                  1000W
                                </option>
                                <option value="psu_1200">
                                  1200W ve üzeri
                                </option>
                              </select>
                            </div>
                            {/* Kasa */}
                            <div className="mb-3">
                              <label className="form-label">
                                Kasa Tipi
                              </label>
                              <div className="form-check">
                                <input className="form-check-input" id="caseGaming" type="checkbox"/>
                                <label className="form-check-label" htmlFor="caseGaming">
                                  Oyuncu Kasası
                                </label>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" id="caseVertical" type="checkbox"/>
                                <label className="form-check-label" htmlFor="caseVertical">
                                  Dikey (Tower)
                                </label>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" id="caseHorizontal" type="checkbox"/>
                                <label className="form-check-label" htmlFor="caseHorizontal">
                                  Yatay (Desktop)
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Fiyat Aralığı */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Fiyat Aralığı
                  </label>
                  <div className="price-range-wrapper">
                    <div className="price-range-slider">
                      <div className="range-bar">
                      </div>
                      <div className="range-handle" data-handle="min">
                      </div>
                      <div className="range-handle" data-handle="max">
                      </div>
                    </div>
                    <div className="price-inputs">
                      <input className="form-control form-control-sm" id="minPrice" placeholder="Min ₺" type="number"/>
                      <span>
                        -
                      </span>
                      <input className="form-control form-control-sm" id="maxPrice" placeholder="Max ₺" type="number"/>
                    </div>
                  </div>
                </div>
                {/* Konum */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Konum
                  </label>
                  <select className="form-select mb-2" id="citySelect">
                    <option value="">
                      İl Seçin
                    </option>
                    {/* İller JavaScript ile doldurulacak */}
                  </select>
                  <select className="form-select" disabled={true} id="districtSelect">
                    <option value="">
                      İlçe Seçin
                    </option>
                    {/* İlçeler JavaScript ile doldurulacak */}
                  </select>
                </div>
                {/* Durum Filtresi */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Ürün Durumu
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" id="condNew" type="checkbox"/>
                    <label className="form-check-label" htmlFor="condNew">
                      Yeni
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" id="condUsed" type="checkbox"/>
                    <label className="form-check-label" htmlFor="condUsed">
                      İkinci El
                    </label>
                  </div>
                </div>
                {/* Satıcı Puanı */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Minimum Satıcı Puanı
                  </label>
                  <div className="rating-filter">
                    <i className="fas fa-star" data-rating="1">
                    </i>
                    <i className="fas fa-star" data-rating="2">
                    </i>
                    <i className="fas fa-star" data-rating="3">
                    </i>
                    <i className="fas fa-star" data-rating="4">
                    </i>
                    <i className="fas fa-star" data-rating="5">
                    </i>
                  </div>
                </div>
                {/* Diğer Filtreler */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    Diğer Özellikler
                  </label>
                  <div className="form-check">
                    <input className="form-check-input" id="hasPhotos" type="checkbox"/>
                    <label className="form-check-label" htmlFor="hasPhotos">
                      Fotoğraflı İlanlar
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" id="hasPrice" type="checkbox"/>
                    <label className="form-check-label" htmlFor="hasPrice">
                      Fiyatı Olanlar
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Sağ İçerik */}
          <div className="col-lg-9">
            {/* Arama Çubuğu */}
            <div className="card mb-4">
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="searchInput" className="form-label">Arama</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="searchInput"
                      placeholder="Ara..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <Button className="btn btn-primary" onClick={search}>
                      <i className="fas fa-search" />
                    </Button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Sıralama</label>
                  <select
                    className="form-select"
                    value={sortBy}
                    onChange={(e) => sortResults(e.target.value)}
                  >
                    <option value="date_desc">Tarih (Yeniden Eskiye)</option>
                    <option value="date_asc">Tarih (Eskiden Yeniye)</option>
                    <option value="name_asc">İsim (A-Z)</option>
                    <option value="name_desc">İsim (Z-A)</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Görünüm</label>
                  <div className="btn-group w-100">
                    <Button
                      className={`btn btn-outline-secondary ${viewMode === 'grid' ? 'active' : ''}`}
                      onClick={() => setViewMode('grid')}
                    >
                      <i className="fas fa-th-large" />
                    </Button>
                    <Button
                      className={`btn btn-outline-secondary ${viewMode === 'list' ? 'active' : ''}`}
                      onClick={() => setViewMode('list')}
                    >
                      <i className="fas fa-list" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {/* Sonuçlar */}
            <div className="row g-4" id="searchResults">
              {/* Sonuçlar JavaScript ile doldurulacak */}
            </div>
            {/* Sayfalama */}
            <nav className="mt-4">
              <ul className="pagination justify-content-center" id="pagination">
                {/* Sayfalama JavaScript ile doldurulacak */}
              </ul>
            </nav>
          </div>
          {/* Sosyal Medya */}
          <div className="col-lg-4 text-center">
            <h5 className="mb-3">
              Sosyal Medya Hesaplarımız
            </h5>
            <div className="social-links">
              <a className="text-primary me-3" href="#">
                <i className="fab fa-facebook fa-lg">
                </i>
              </a>
              <a className="text-info me-3" href="#">
                <i className="fab fa-twitter fa-lg">
                </i>
              </a>
              <a className="text-danger me-3" href="#">
                <i className="fab fa-instagram fa-lg">
                </i>
              </a>
              <a className="text-primary" href="#">
                <i className="fab fa-linkedin fa-lg">
                </i>
              </a>
            </div>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="footer mt-auto py-5 border-top" style={{ backgroundColor: 'var(--sb-bg)' }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Hakkımızda</h5>
              <p className="text-secondary">
                SadeceBilgisayar.com, sıfır veya İkinci el teknolojik ürünleri güvenilir bir şekilde alım veya satım yapabileceğiniz bir platformdur.
              </p>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Önemli Tavsiyeler</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline text-nowrap" to="/masaustu_tavsiyeler">
                    Masaüstü alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/laptop-tavsiyeler">
                    Laptop alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/donanim-tavsiyeler">
                    Donanım alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">İletişim</h5>
              <div className="contact-info">
                <p className="text-secondary mb-2">Görüşleriniz ve şikayetleriniz için</p>
                <p className="text-secondary mb-2">
                  <i className="fas fa-envelope me-2"></i>
                  info@sadecebilgisayar.com
                </p>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3">Sosyal Medya Hesaplarımız</h5>
              <div className="social-links">
                <a className="text-primary me-4" href="#">
                  <i className="fab fa-facebook fa-3x"></i>
                </a>
                <a className="text-danger me-4" href="#">
                  <i className="fab fa-instagram fa-3x"></i>
                </a>
                <a className="text-danger" href="#">
                  <i className="fab fa-youtube fa-3x"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom mt-5 pt-4 border-top">
            <div className="row">
              <div className="col-md-6">
                <p className="text-secondary mb-0">© 2024 SadeceBilgisayar.com - Tüm hakları saklıdır.</p>
              </div>
              <div className="col-md-6 text-md-end">
                <Link className="text-secondary me-3" to="/gizlilik-politikasi">Gizlilik Politikası</Link>
                <Link className="text-secondary me-3" to="/kullanici-sozlesmesi">Kullanım Koşulları</Link>
                <Link className="text-secondary" to="/cerez-politikasi">Çerez Politikası</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js">
      </script>
      <script src="https://cdn.jsdelivr.net/npm/nouislider/distribute/nouislider.min.js">
      </script>
      <script src="../assets/js/search.js">
      </script>
    </div>
  );
}
